interface StarRatingProps {
  rating: number;
  size?: "sm" | "md" | "lg";
}

export default function StarRating({ rating, size = "md" }: StarRatingProps) {
  const sizeClass =
    size === "sm" ? "text-xs" : size === "lg" ? "text-xl" : "text-base";

  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = rating >= star;
        const half = !filled && rating >= star - 0.5;
        return (
          <span
            key={star}
            className={`${sizeClass} ${filled || half ? "text-amber-400" : "text-gray-300"}`}
          >
            <i
              className={
                filled
                  ? "ri-star-fill"
                  : half
                    ? "ri-star-half-fill"
                    : "ri-star-line"
              }
            ></i>
          </span>
        );
      })}
    </div>
  );
}
